"use strict";import{css as t}from"lit";const o=t`:host{display:block;flex-shrink:0;height:100%;position:relative;transition-property:transform;width:100%}::slotted(*){max-width:100%}`;export default o;
//# sourceMappingURL=testimonial-slide.css.js.map
